// extracted by mini-css-extract-plugin
module.exports = {"background":"Homepage_background__1LD3n","home":"Homepage_home__2ieb3","intro":"Homepage_intro__1Q4FE"};